import { configureStore } from '@reduxjs/toolkit'
import appSlice from './slice/appSlice'
import userSlice from './user/userSlice'
import channelsSlice from './channelsSlice/channelsSlice'
import videosSlice from './videosSlice/videosSlice'
import audiosSlice from './audiosSlice/audiosSlice'
import subtitleSlice from './subtitleSlice/subtitleSlice'
import watermarksSlice from './watermarksSlice/watermarksSlice'
import profilesSlice from './profilesSlice/profilesSlice'
import dubSlice from './dubSlice/dubSlice'
import adsSlice from './adsSlice/adsSlice'
import convertInfoSlice from './convertInfoSlice/convertInfoSlice'
import tagsSlice from './tagsSlice/tagsSlice'
import filesSlice from './filesSlice/filesSlice'
import streamsSlice from './streamsSlice/streamsSlice'
import streamRecordsSlice from './streamRecordsSlice/streamRecordsSlice'
import adminMovieConvertInfoSlice from './adminMovieConvertInfoSlice/adminMovieConvertInfoSlice'
import adminAudioConvertInfoSlice from './adminAudioConvertInfoSlice/adminAudioConvertInfoSlice'
import { apiRtkSlice } from './apiRtkSlice/apiRtkSlice'

export const store = configureStore({
  reducer: {
    app: appSlice,
    user: userSlice,
    channels: channelsSlice,
    videos: videosSlice,
    audios: audiosSlice,
    subtitles: subtitleSlice,
    dubs: dubSlice,
    watermarks: watermarksSlice,
    profiles: profilesSlice,
    ads: adsSlice,
    convertInfo: convertInfoSlice,
    tags: tagsSlice,
    files: filesSlice,
    streams: streamsSlice,
    streamRecords: streamRecordsSlice,
    adminMovieConvertInfo: adminMovieConvertInfoSlice,
    adminAudioConvertInfo: adminAudioConvertInfoSlice,
    [apiRtkSlice.reducerPath]: apiRtkSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiRtkSlice.middleware),
  devTools: true,
})
